import React from 'react';
import { Pagination } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Simple React 19 compatible pagination component
const Paginator = ({ currentPage, totalPages, onPageChange, ...props }) => {
    const handlePageChange = (page) => {
        console.log('Paginator handlePageChange called with:', { page, currentPage, totalPages, onPageChange: typeof onPageChange });
        if (page >= 1 && page <= totalPages && page !== currentPage) {
            console.log('Calling onPageChange with page:', page);
            onPageChange(page);
        } else {
            console.log('Page change blocked:', { page, currentPage, totalPages, condition: page >= 1 && page <= totalPages && page !== currentPage });
        }
    };

    const renderPageItems = () => {
        const items = [];
        const maxVisiblePages = 5;
        const halfVisible = Math.floor(maxVisiblePages / 2);
        
        let startPage = Math.max(1, currentPage - halfVisible);
        let endPage = Math.min(totalPages, currentPage + halfVisible);
        
        // Adjust if we're near the beginning or end
        if (endPage - startPage + 1 < maxVisiblePages) {
            if (startPage === 1) {
                endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
            } else {
                startPage = Math.max(1, endPage - maxVisiblePages + 1);
            }
        }
        
        // First page
        if (startPage > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" />);
            }
        }
        
        // Page numbers
        for (let i = startPage; i <= endPage; i++) {
            items.push(
                <Pagination.Item 
                    key={i} 
                    active={i === currentPage} 
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }
        
        // Last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" />);
            }
            items.push(
                <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }
        
        return items;
    };

    return (
        <Pagination {...props}>
            <Pagination.First 
                disabled={currentPage === 1} 
                onClick={() => handlePageChange(1)} 
            />
            <Pagination.Prev 
                disabled={currentPage === 1} 
                onClick={() => handlePageChange(currentPage - 1)} 
            />
            {renderPageItems()}
            <Pagination.Next 
                disabled={currentPage === totalPages} 
                onClick={() => handlePageChange(currentPage + 1)} 
            />
            <Pagination.Last 
                disabled={currentPage === totalPages} 
                onClick={() => handlePageChange(totalPages)} 
            />
        </Pagination>
    );
};

Paginator.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};

export default Paginator;
